import { render, staticRenderFns } from "./CardFormFiveAppeal.vue?vue&type=template&id=70b5a3a6&scoped=true"
import script from "./CardFormFiveAppeal.vue?vue&type=script&lang=js"
export * from "./CardFormFiveAppeal.vue?vue&type=script&lang=js"
import style0 from "./CardFormFiveAppeal.vue?vue&type=style&index=0&id=70b5a3a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b5a3a6",
  null
  
)

export default component.exports